/* eslint-disable no-unused-expressions */

import axios from "axios";
import sysJwt from "./sysJwt";
import { toastSuccess, toastError } from "./sysToast";
import SaveAs from "file-saver";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function post(url, data, updateIsLoading, responseType = "json") {
  updateIsLoading(true);

  var postData =
    data instanceof FormData
      ? data
      : {
          ...data,
        };

  return axios
    .post(url, postData, {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("748784"),
        DFP: sysJwt.getIsDefaultPwd(),
      },

      responseType: responseType,
    })
    .then((apiResponse) => {
      updateIsLoading(false);
      console.log(apiResponse);

      if (apiResponse.headers.reftoken) {
        sessionStorage.setItem("748784", apiResponse.headers.reftoken);
      }

      if (sysJwt.getIsDefaultPwd() === "true") {
        if (window.location.pathname !== "/dashboard/changepassword") {
          toastError(
            "يرجى تغيير كلمة السر الافتراضية للنظام بكلمة سر جديدة خاصة بك"
          );
          sleep(2000).then(() =>
            window.location.replace("/dashboard/changepassword")
          );
        }
      }

      if (apiResponse.data.respCode === 0) {
        apiResponse.data.respDesc
          ? toastSuccess(apiResponse.data.respDesc)
          : null;
        return apiResponse;
      } else {
        if (apiResponse.status === 401) {
          window.location.replace("/login");
        } else {
          toastError(apiResponse.data.respDesc);
          return apiResponse;
        }
      }
    })
    .catch((apiResponse) => {
      updateIsLoading(false);
      if (apiResponse.response.status === 401) {
        window.location.replace("/login");
      } else if (apiResponse.response.status === 403) {
        toastError(
          "المدخلات تحتوي على حروف محظورة، الرجاء حذفها ثم المحاولة مجدداً"
        );
      } else {
        toastError(apiResponse.response.statusText);
      }

      return apiResponse;
    });
}

export function downloadContractFile(filePath, updateIsLoading) {
  updateIsLoading(true);

  return axios
    .get("/api/data/DownloadContractFile?filepath=" + filePath, {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("748784"),
        DFP: sysJwt.getIsDefaultPwd(),
      },
      responseType: "blob",
    })
    .then((apiResponse) => {
      updateIsLoading(false);

      if (apiResponse.status === 200) {
        SaveAs(
          new Blob([apiResponse.data], { type: "application/octet-stream" }),
          apiResponse.headers["content-disposition"]
            .split("filename=")[1]
            .split(";")[0]
            .replaceAll('"', ""),
          { autoBOM: false }
        );
      } else {
        if (apiResponse.status === 401) {
          window.location.replace("/login");
        } else {
          toastError(apiResponse.data.respDesc);
          return apiResponse;
        }
      }
    })
    .catch((apiResponse) => {
      updateIsLoading(false);
      if (apiResponse.response.status === 401) {
        window.location.replace("/login");
      } else if (apiResponse.response.status === 403) {
        toastError(
          "The entries contain prohibited characters, please delete them and try again"
        );
      } else {
        toastError(apiResponse.response.statusText);
      }

      return apiResponse;
    });
}
